<h4>Transporte Ferroviario</h4>
<div class="row">
    <div class="col-6">
        <mat-form-field appearance="fill" [formGroup]="FormTransporte">
            <mat-label>Seleccione transporte ferroviario </mat-label>
            <mat-select formControlName="ferroviario" name="ferroviario"
                (selectionChange)="asingdataForm($event.value)">
                <mat-option [value]="0">
                    Nuevo transporte ferroviario
                </mat-option>
                <mat-option *ngFor="let ferroviario of ferroviarios" [value]="ferroviario">
                    {{ferroviario.id}} - {{ferroviario.attributes.nombreAseg}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="col-6">
        <br>
        <button class="fuse-mat-button-rounded mgbutton" mat-flat-button (click)="EliminarFerroviario()">Eliminar</button>
        <button class="fuse-mat-button-rounded mgbutton" mat-flat-button [color]="'primary'"
            (click)="GuardaFormulario()">Guardar</button>
    </div>
</div>
<div class="row">
    <!--  -->
    <div class="col-sm-3">
        <!-- <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
            <mat-label>TipoDeServicio <span class="required">*</span></mat-label>
            <input matInput formControlName="servicio">
        </mat-form-field>
        <div *ngIf="FormTransporte.controls.servicio.invalid && FormTransporte.controls.servicio.touched">
            <div *ngIf="FormTransporte.controls.servicio.errors.required" style="font-size: 12px;color: red;">El campo
                es requerido.</div>
        </div> -->
        <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
            <mat-label>TipoDeServicio </mat-label>
            <input matInput aria-label="State" matInput formControlName="servicio" [matAutocomplete]="autoServicio">
            <span class="text-danger"
                *ngIf="FormTransporte.controls.servicio.invalid && FormTransporte.controls.servicio.touched">
                Campo requerido
            </span>
            <mat-autocomplete #autoServicio="matAutocomplete" [displayWith]="displayServicio">
                <mat-option *ngFor="let item of opcionesFiltradasServicios| async" [value]="item.id"
                    style="height: 35px;">
                    <span> {{item.attributes?.clave}} - {{item.attributes?.tipoServicio}}</span>
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </div>

    <!--  -->
    <div class="col-sm-3">
        <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
            <mat-label>NombreAseg</mat-label>
            <input matInput formControlName="nombre">
        </mat-form-field>
        <div *ngIf="FormTransporte.controls.nombre.invalid && FormTransporte.controls.nombre.touched">
            <div *ngIf="FormTransporte.controls.nombre.errors.required" style="font-size: 12px;color: red;">El campo es
                requerido.</div>
        </div>
    </div>
    <!--  -->
    <div class="col-sm-3">
        <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
            <mat-label>NumPolizaSeguro</mat-label>
            <input matInput formControlName="poliza">
        </mat-form-field>
        <div *ngIf="FormTransporte.controls.poliza.invalid && FormTransporte.controls.poliza.touched">
            <div *ngIf="FormTransporte.controls.poliza.errors.required" style="font-size: 12px;color: red;">El campo es
                requerido.</div>
        </div>
    </div>
    <!--  -->
    <div class="col-sm-3">
        <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
            <mat-label>concecionario*</mat-label>
            <input matInput formControlName="concecionario">
        </mat-form-field>
        <div *ngIf="FormTransporte.controls.concecionario.invalid && FormTransporte.controls.concecionario.touched">
            <div *ngIf="FormTransporte.controls.concecionario.errors.required" style="font-size: 12px;color: red;">El
                campo es requerido.</div>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-sm-1">&nbsp;</div>
    <div class="col-sm-11">
        <h5>Derechos de paso</h5>
    </div>
    <div class="col-sm-1">&nbsp;</div>
    <div class="col-sm-11">
        <div class="row justify-content-start align-items-center barraGestorPagos mt-4">
            <div class="col-sm-12 col-md-1 col-xl-1">
                <button (click)="addDerechosPaso()" mat-flat-button color="primary">
                    <mat-icon svgIcon="heroicons_outline:plus-sm"></mat-icon>
                </button>
            </div>
            <div class="col-sm-12 col-md-1 col-xl-1">
                <button (click)="removeDerechosPaso()" [disabled]="removeDisabledDP" mat-flat-button color="warn">
                    <mat-icon svgIcon="heroicons_outline:minus-sm"></mat-icon>
                </button>
            </div>
        </div>
    </div>
    <div class="col-sm-1">&nbsp;</div>
    <div class="col-sm-11">
        <!-- <app-derechos-paso *ngFor="let valores of componentesValores" [datos]="valores"></app-derechos-paso> -->
        <app-derechos-paso *ngFor="let p of countDerechosPaso" [id]="p" [dataDerechoPaso]="p.data"></app-derechos-paso>
        <hr>
    </div>
</div>


<div class="row">
    <div class="col-sm-1">&nbsp;</div>
    <div class="col-sm-11">
        <h5>Carro</h5>
    </div>
    <div class="col-sm-1">&nbsp;</div>
    <div class="col-sm-11">
        <div class="row justify-content-start align-items-center barraGestorPagos mt-4">
            <div class="col-sm-12 col-md-1 col-xl-1">
                <button (click)="addCarro()" mat-flat-button color="primary">
                    <mat-icon svgIcon="heroicons_outline:plus-sm"></mat-icon>
                </button>
            </div>
            <div class="col-sm-12 col-md-1 col-xl-1">
                <button (click)="removeCarro()" [disabled]="removeDisabledCarro" mat-flat-button color="warn">
                    <mat-icon svgIcon="heroicons_outline:minus-sm"></mat-icon>
                </button>
            </div>
        </div>
    </div>
    <div class="col-sm-1">&nbsp;</div>
    <div class="col-sm-11">
        <app-carro *ngFor="let p of countCarro" [id]="p" [carros]="p.data"></app-carro>
        <hr>
    </div>
</div>